<script>
export default {
  data() {
    return {
      observed: this.$storage.observed,
      visible: true,
      lastScrollY: 0,
    }
  },
  mounted() {
    this._onScroll = () => {
      let y = window.scrollY
      this.visible = y < this.lastScrollY || y < 10
      this.lastScrollY = y
    }
    window.addEventListener('scroll', this._onScroll, { passive: true })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this._onScroll)
  },
  computed: {
    currentShortName() {
      return this.observed.currentEventShortName
    },
    eventRoute() {
      return this.currentShortName ? `/${this.currentShortName}` : '/'
    },
    activityRoute() {
      return '/ai-chat'
    },
    numUnreadMessages() {
      return this.observed.numDirectUnreadMessages
    },
    isEvent() {
      let name = this.$route.name || ''
      if (name === 'EventHome') return true
      return name.startsWith('Event ') && name !== 'EventInfo'
    },
    isActivity() {
      return this.$route.name === 'AiChat'
    },
    isTownSquare() {
      return this.$route.path === '/channel-town-square'
    },
    isMessages() {
      return this.$route.path === '/user-profile/contacts'
    },
    isProfile() {
      if (this.isMessages) return false
      return (this.$route.path || '').startsWith('/user-profile')
    },
  },
  watch: {
    '$route.params.shortName': {
      immediate: true,
      handler(shortName) {
        if (shortName) {
          this.$storage.setCurrentEventShortName(shortName)
        }
      }
    }
  }
}
</script>

<template>
  <nav class="nav fixed-bottom bg-light border-top d-flex justify-content-around align-items-center px-1 c-bottom-nav"
       :class="{ 'c-hidden': !visible }">
    <router-link v-if="$route.name === 'EventHome'" to="/"
                 class="d-flex flex-column align-items-center flex-fill text-decoration-none small c-inactive">
      <i class="fas fa-home fs-5"></i>
      <span>Home</span>
    </router-link>
    <router-link v-if="$route.name !== 'EventHome'" :to="eventRoute"
                 class="d-flex flex-column align-items-center flex-fill text-decoration-none small"
                 :class="isEvent ? 'c-active' : 'c-inactive'">
      <i class="fas fa-calendar-alt fs-5"></i>
      <span>{{ currentShortName ? currentShortName.toUpperCase() : 'Event' }}</span>
    </router-link>
    <router-link to="/channel-town-square"
                 class="d-flex flex-column align-items-center flex-fill text-decoration-none small"
                 :class="isTownSquare ? 'c-active' : 'c-inactive'">
      <i class="bi bi-people fs-5"></i>
      <span>Town Square</span>
    </router-link>
    <router-link :to="activityRoute" class="d-flex flex-column align-items-center flex-fill text-decoration-none small"
                 :class="isActivity ? 'c-active' : 'c-inactive'">
      <i class="bi bi-chat-dots fs-5"></i>
      <span>HRmine</span>
    </router-link>
    <router-link to="/user-profile/contacts" class="d-flex flex-column align-items-center flex-fill text-decoration-none small"
                 :class="isMessages ? 'c-active' : 'c-inactive'">
      <span class="position-relative d-inline-block">
        <i class="fas fa-envelope fs-5"></i>
        <span v-if="numUnreadMessages"
              class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
              style="font-size: 0.6rem;">{{ numUnreadMessages }}</span>
      </span>
      <span>Messages</span>
    </router-link>
    <router-link to="/user-profile" class="d-flex flex-column align-items-center flex-fill text-decoration-none small"
                 :class="isProfile ? 'c-active' : 'c-inactive'">
      <i class="fas fa-user fs-5"></i>
      <span>Profil</span>
    </router-link>
  </nav>
</template>

<style scoped>
.c-inactive { color: #6c757d; }
.c-active { color: var(--bs-primary); }
.c-bottom-nav {
  height: 56px;
  z-index: 1030;
  padding-bottom: env(safe-area-inset-bottom);
  transition: transform 0.3s ease;
}
.c-hidden {
  transform: translateY(100%);
}
</style>
